export default "__VITE_ASSET__dd95bc0c__"